(function () {

  //var win = $(window);
  //var helpers = require('../global/helpers');
  var FormTabsEngine = require('../global/form-tabs-engine');
  var hpFormsOptions = require('./forms-defaults')();
  var PreparePostInit = require('../global/prepare-post-init-functions');

  hpFormsOptions = PreparePostInit(hpFormsOptions, []);

  var hpForms = new FormTabsEngine({
    'form-1': ['airticketForm', hpFormsOptions.letenky],
    'form-2': ['accomodationForm', hpFormsOptions.ubytovani]
  });

  // Inicializace prvního formuláře
  hpForms.init('form-1');

  // Widget nejlevnejsi letenky
  $('#action-prices').airticketOffersWidget(
    hpFormsOptions.airticketOffersWidget
  );


})();
